// @ts-ignore
import { hasProp, assert } from "@utils/assertion";
// @ts-ignore
import { isArray } from "@utils/arrayUtils";
// @ts-ignore
import { parseJsonWithNumbersAsBigint, renderJsonWithNumbersAsBigint, type ParserResult } from "@utils/json";
// @ts-ignore
import { toBase64 } from "@utils/blobUtils";
// @ts-ignore
import { DateTime } from "luxon";
// @ts-ignore
import { type ReadonlyUint8Array } from "@utils/arrayUtils";
import type { Language, PromoBoxTag, PromoBoxEditView } from "../schema";

export function serialize_PromoBoxEditView(obj: PromoBoxEditView): string {
  const serialized = ((value: {
    backgroundColor: string | null;
    brightTextColor: boolean;
    corporateId: number;
    designApproved: boolean;
    endsAt: { year: number; month: number; day: number } | null;
    excludedLanguages: Language[];
    imageUri: string;
    localizedDescription: { additionalProperties: Record<string, string> };
    localizedImageUris: { additionalProperties: Record<string, string> };
    localizedTitle: { additionalProperties: Record<string, string> };
    localizedWebLinks: { additionalProperties: Record<string, string> };
    loggedIn: boolean;
    loggedOut: boolean;
    mobile: boolean;
    name: string;
    promoBoxId: number;
    requiredFeatures: string[];
    startsAt: { year: number; month: number; day: number } | null;
    tag: PromoBoxTag;
    web: boolean;
    webLink: string;
  }): unknown => {
    return {
      backgroundColor: ((value: string | null): unknown => {
        if (value === null) {
          return null;
        }
        return value;
      })(value["backgroundColor"]),
      brightTextColor: ((value: boolean): unknown => {
        return value;
      })(value["brightTextColor"]),
      corporateId: ((value: number): unknown => {
        return value;
      })(value["corporateId"]),
      designApproved: ((value: boolean): unknown => {
        return value;
      })(value["designApproved"]),
      endsAt: ((value: { year: number; month: number; day: number } | null): unknown => {
        if (value === null) {
          return null;
        }
        return `${value.year.toFixed().padStart(4, "0")}-${value.month.toFixed().padStart(2, "0")}-${value.day.toFixed().padStart(2, "0")}`;
      })(value["endsAt"]),
      excludedLanguages: ((value: Language[]): unknown => {
        return value.map((value: "en" | "de" | "es" | "ru" | "zh" | "pt" | "fr"): unknown => {
          return value;
        });
      })(value["excludedLanguages"]),
      imageUri: ((value: string): unknown => {
        return value;
      })(value["imageUri"]),
      localizedDescription: ((value: { additionalProperties: Record<string, string> }): unknown => {
        const unordered_obj: Record<string, unknown> = {
          ...Object.fromEntries(
            Object.entries(value.additionalProperties).map(([propertyKey, propertyValue]) => {
              return [
                propertyKey,
                ((value: string): unknown => {
                  return value;
                })(propertyValue),
              ];
            }),
          ),
        };
        return Object.keys(unordered_obj)
          .sort()
          .reduce(
            (obj, key) => {
              obj[key] = unordered_obj[key];
              return obj;
            },
            {} as Record<string, unknown>,
          );
      })(value["localizedDescription"]),
      localizedImageUris: ((value: { additionalProperties: Record<string, string> }): unknown => {
        const unordered_obj: Record<string, unknown> = {
          ...Object.fromEntries(
            Object.entries(value.additionalProperties).map(([propertyKey, propertyValue]) => {
              return [
                propertyKey,
                ((value: string): unknown => {
                  return value;
                })(propertyValue),
              ];
            }),
          ),
        };
        return Object.keys(unordered_obj)
          .sort()
          .reduce(
            (obj, key) => {
              obj[key] = unordered_obj[key];
              return obj;
            },
            {} as Record<string, unknown>,
          );
      })(value["localizedImageUris"]),
      localizedTitle: ((value: { additionalProperties: Record<string, string> }): unknown => {
        const unordered_obj: Record<string, unknown> = {
          ...Object.fromEntries(
            Object.entries(value.additionalProperties).map(([propertyKey, propertyValue]) => {
              return [
                propertyKey,
                ((value: string): unknown => {
                  return value;
                })(propertyValue),
              ];
            }),
          ),
        };
        return Object.keys(unordered_obj)
          .sort()
          .reduce(
            (obj, key) => {
              obj[key] = unordered_obj[key];
              return obj;
            },
            {} as Record<string, unknown>,
          );
      })(value["localizedTitle"]),
      localizedWebLinks: ((value: { additionalProperties: Record<string, string> }): unknown => {
        const unordered_obj: Record<string, unknown> = {
          ...Object.fromEntries(
            Object.entries(value.additionalProperties).map(([propertyKey, propertyValue]) => {
              return [
                propertyKey,
                ((value: string): unknown => {
                  return value;
                })(propertyValue),
              ];
            }),
          ),
        };
        return Object.keys(unordered_obj)
          .sort()
          .reduce(
            (obj, key) => {
              obj[key] = unordered_obj[key];
              return obj;
            },
            {} as Record<string, unknown>,
          );
      })(value["localizedWebLinks"]),
      loggedIn: ((value: boolean): unknown => {
        return value;
      })(value["loggedIn"]),
      loggedOut: ((value: boolean): unknown => {
        return value;
      })(value["loggedOut"]),
      mobile: ((value: boolean): unknown => {
        return value;
      })(value["mobile"]),
      name: ((value: string): unknown => {
        return value;
      })(value["name"]),
      promoBoxId: ((value: number): unknown => {
        return value;
      })(value["promoBoxId"]),
      requiredFeatures: ((value: string[]): unknown => {
        return value.map((value: string): unknown => {
          return value;
        });
      })(value["requiredFeatures"]),
      startsAt: ((value: { year: number; month: number; day: number } | null): unknown => {
        if (value === null) {
          return null;
        }
        return `${value.year.toFixed().padStart(4, "0")}-${value.month.toFixed().padStart(2, "0")}-${value.day.toFixed().padStart(2, "0")}`;
      })(value["startsAt"]),
      tag: ((
        value:
          | "UNDEFINED"
          | "EXPERT_WEBINAR"
          | "PRO_TALK"
          | "FEATURED"
          | "FEATURED_SUMMARY"
          | "FEATURED_ACTIONABLE"
          | "FEATURED_TOPIC"
          | "EMERGING_TREND"
          | "INTERNATIONAL_DAY"
          | "LEARNING_AT_WORK_WEEK"
          | "Q_A"
          | "VALUES_AND_CAPABILITIES"
          | "RECOMMENDED_READS"
          | "INTERNAL_THOUGHT_LEADER"
          | "READING_CALENDAR"
          | "NEW"
          | "SPOTLIGHT"
          | "PROMOTION"
          | "DEAL"
          | "NEWS"
          | "CAMPAIGN"
          | "BOOK_AWARD",
      ): unknown => {
        return value;
      })(value["tag"]),
      web: ((value: boolean): unknown => {
        return value;
      })(value["web"]),
      webLink: ((value: string): unknown => {
        return value;
      })(value["webLink"]),
    };
  })(obj);
  return renderJsonWithNumbersAsBigint(serialized);
}
export function deserialize_PromoBoxEditView(str: string): ParserResult<PromoBoxEditView> {
  return ((
    value: unknown,
  ): ParserResult<{
    backgroundColor: string | null;
    brightTextColor: boolean;
    corporateId: number;
    designApproved: boolean;
    endsAt: { year: number; month: number; day: number } | null;
    excludedLanguages: Language[];
    imageUri: string;
    localizedDescription: { additionalProperties: Record<string, string> };
    localizedImageUris: { additionalProperties: Record<string, string> };
    localizedTitle: { additionalProperties: Record<string, string> };
    localizedWebLinks: { additionalProperties: Record<string, string> };
    loggedIn: boolean;
    loggedOut: boolean;
    mobile: boolean;
    name: string;
    promoBoxId: number;
    requiredFeatures: string[];
    startsAt: { year: number; month: number; day: number } | null;
    tag: PromoBoxTag;
    web: boolean;
    webLink: string;
  }> => {
    if (typeof value !== "object") {
      return { success: false, reason: `[#/components/schemas/PromoBoxEditView]: '${value}' expected to be of type 'object'.` };
    }
    if (value === null) {
      return { success: false, reason: `[#/components/schemas/PromoBoxEditView]: '${value}' expected to not be null.` };
    }
    if (!hasProp(value, "backgroundColor")) {
      return { success: false, reason: `[#/components/schemas/PromoBoxEditView/backgroundColor]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'backgroundColor'.` };
    }
    const parsed_backgroundColor = ((): ParserResult<string | null> => {
      return ((value: unknown): ParserResult<string | null> => {
        if (value === null) {
          return { success: true, value: null };
        }
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/PromoBoxEditView/backgroundColor]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["backgroundColor"]);
    })();
    if (!parsed_backgroundColor.success) {
      return { success: false, reason: parsed_backgroundColor.reason };
    }
    if (!hasProp(value, "brightTextColor")) {
      return { success: false, reason: `[#/components/schemas/PromoBoxEditView/brightTextColor]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'brightTextColor'.` };
    }
    const parsed_brightTextColor = ((): ParserResult<boolean> => {
      return ((value: unknown): ParserResult<boolean> => {
        if (typeof value !== "boolean") {
          return { success: false, reason: `[#/components/schemas/PromoBoxEditView/brightTextColor]: '${value}' expected to be of type boolean.` };
        }
        return { success: true, value: value };
      })(value["brightTextColor"]);
    })();
    if (!parsed_brightTextColor.success) {
      return { success: false, reason: parsed_brightTextColor.reason };
    }
    if (!hasProp(value, "corporateId")) {
      return { success: false, reason: `[#/components/schemas/PromoBoxEditView/corporateId]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'corporateId'.` };
    }
    const parsed_corporateId = ((): ParserResult<number> => {
      return ((value: unknown): ParserResult<number> => {
        if (typeof value === "number") {
          return { success: true, value: value };
        }
        return { success: false, reason: `[#/components/schemas/PromoBoxEditView/corporateId]: '${value}' expected to be of type number.` };
      })(value["corporateId"]);
    })();
    if (!parsed_corporateId.success) {
      return { success: false, reason: parsed_corporateId.reason };
    }
    if (!hasProp(value, "designApproved")) {
      return { success: false, reason: `[#/components/schemas/PromoBoxEditView/designApproved]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'designApproved'.` };
    }
    const parsed_designApproved = ((): ParserResult<boolean> => {
      return ((value: unknown): ParserResult<boolean> => {
        if (typeof value !== "boolean") {
          return { success: false, reason: `[#/components/schemas/PromoBoxEditView/designApproved]: '${value}' expected to be of type boolean.` };
        }
        return { success: true, value: value };
      })(value["designApproved"]);
    })();
    if (!parsed_designApproved.success) {
      return { success: false, reason: parsed_designApproved.reason };
    }
    if (!hasProp(value, "endsAt")) {
      return { success: false, reason: `[#/components/schemas/PromoBoxEditView/endsAt]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'endsAt'.` };
    }
    const parsed_endsAt = ((): ParserResult<{ year: number; month: number; day: number } | null> => {
      return ((value: unknown): ParserResult<{ year: number; month: number; day: number } | null> => {
        if (value === null) {
          return { success: true, value: null };
        }
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/PromoBoxEditView/endsAt]: '${value}' expected to be of type string.` };
        }
        const parsed = DateTime.fromFormat(value, "yyyy-LL-dd");
        if (!parsed.isValid) {
          return { success: false, reason: `[#/components/schemas/PromoBoxEditView/endsAt]: '${value}' expected to be a valid date in format yyyy-LL-dd.` };
        }
        return { success: true, value: { year: parsed.year, month: parsed.month, day: parsed.day } };
      })(value["endsAt"]);
    })();
    if (!parsed_endsAt.success) {
      return { success: false, reason: parsed_endsAt.reason };
    }
    if (!hasProp(value, "excludedLanguages")) {
      return { success: false, reason: `[#/components/schemas/PromoBoxEditView/excludedLanguages]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'excludedLanguages'.` };
    }
    const parsed_excludedLanguages = ((): ParserResult<Language[]> => {
      return ((value: unknown): ParserResult<Language[]> => {
        if (!isArray(value)) {
          return { success: false, reason: `[#/components/schemas/PromoBoxEditView/excludedLanguages]: '${value}' expected to be an array.` };
        }
        const parsed = value.map((value: unknown): ParserResult<Language> => {
          return ((value: unknown): ParserResult<"en" | "de" | "es" | "ru" | "zh" | "pt" | "fr"> => {
            if (typeof value !== "string") {
              return { success: false, reason: `[#/components/schemas/Language]: '${value}' expected to be of type string.` };
            }
            switch (value) {
              case "en":
                return { success: true, value: "en" };
              case "de":
                return { success: true, value: "de" };
              case "es":
                return { success: true, value: "es" };
              case "ru":
                return { success: true, value: "ru" };
              case "zh":
                return { success: true, value: "zh" };
              case "pt":
                return { success: true, value: "pt" };
              case "fr":
                return { success: true, value: "fr" };
              default:
                return { success: false, reason: `[#/components/schemas/Language]: '${value}' expected to be enum, one of 'en, de, es, ru, zh, pt, fr'.` };
            }
          })(value);
        });
        if (parsed.find((value) => !value.success) !== undefined) {
          return {
            success: false,
            reason: `[#/components/schemas/PromoBoxEditView/excludedLanguages]: Reason(s): '${parsed
              .filter((p) => !p.success)
              .map((p) => p.reason)
              .join(", ")}'.`,
          };
        }
        return {
          success: true,
          value: parsed.map((entry) => {
            assert(entry.success == true);
            return entry.value;
          }),
        };
      })(value["excludedLanguages"]);
    })();
    if (!parsed_excludedLanguages.success) {
      return { success: false, reason: parsed_excludedLanguages.reason };
    }
    if (!hasProp(value, "imageUri")) {
      return { success: false, reason: `[#/components/schemas/PromoBoxEditView/imageUri]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'imageUri'.` };
    }
    const parsed_imageUri = ((): ParserResult<string> => {
      return ((value: unknown): ParserResult<string> => {
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/PromoBoxEditView/imageUri]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["imageUri"]);
    })();
    if (!parsed_imageUri.success) {
      return { success: false, reason: parsed_imageUri.reason };
    }
    if (!hasProp(value, "localizedDescription")) {
      return { success: false, reason: `[#/components/schemas/PromoBoxEditView/localizedDescription]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'localizedDescription'.` };
    }
    const parsed_localizedDescription = ((): ParserResult<{ additionalProperties: Record<string, string> }> => {
      return ((value: unknown): ParserResult<{ additionalProperties: Record<string, string> }> => {
        if (typeof value !== "object") {
          return { success: false, reason: `[#/components/schemas/PromoBoxEditView/localizedDescription]: '${value}' expected to be of type 'object'.` };
        }
        if (value === null) {
          return { success: false, reason: `[#/components/schemas/PromoBoxEditView/localizedDescription]: '${value}' expected to not be null.` };
        }
        const parsed_additionalProperties = ((): ParserResult<Record<string, string>> => {
          const parsed = Object.entries(value).map(([key, value]): [string, ParserResult<string>] => {
            return [
              key,
              ((value: unknown): ParserResult<string> => {
                if (typeof value !== "string") {
                  return { success: false, reason: `[#/components/schemas/PromoBoxEditView/localizedDescription/additionalProperty]: '${value}' expected to be of type string.` };
                }
                return { success: true, value: value };
              })(value),
            ];
          });
          if (parsed.find(([_, value]) => !value.success) !== undefined) {
            return {
              success: false,
              reason: `[#/components/schemas/PromoBoxEditView/localizedDescription]: Reason(s): '${parsed
                .map(([_, value]) => value)
                .filter((p) => !p.success)
                .map((p) => p.reason)
                .join(", ")}'.`,
            };
          }
          return {
            success: true,
            value: Object.fromEntries(
              parsed.map(([key, value]) => {
                assert(value.success);
                return [key, value.value];
              }),
            ),
          };
        })();
        if (!parsed_additionalProperties.success) {
          return { success: false, reason: parsed_additionalProperties.reason };
        }
        return { success: true, value: { additionalProperties: parsed_additionalProperties.value } };
      })(value["localizedDescription"]);
    })();
    if (!parsed_localizedDescription.success) {
      return { success: false, reason: parsed_localizedDescription.reason };
    }
    if (!hasProp(value, "localizedImageUris")) {
      return { success: false, reason: `[#/components/schemas/PromoBoxEditView/localizedImageUris]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'localizedImageUris'.` };
    }
    const parsed_localizedImageUris = ((): ParserResult<{ additionalProperties: Record<string, string> }> => {
      return ((value: unknown): ParserResult<{ additionalProperties: Record<string, string> }> => {
        if (typeof value !== "object") {
          return { success: false, reason: `[#/components/schemas/PromoBoxEditView/localizedImageUris]: '${value}' expected to be of type 'object'.` };
        }
        if (value === null) {
          return { success: false, reason: `[#/components/schemas/PromoBoxEditView/localizedImageUris]: '${value}' expected to not be null.` };
        }
        const parsed_additionalProperties = ((): ParserResult<Record<string, string>> => {
          const parsed = Object.entries(value).map(([key, value]): [string, ParserResult<string>] => {
            return [
              key,
              ((value: unknown): ParserResult<string> => {
                if (typeof value !== "string") {
                  return { success: false, reason: `[#/components/schemas/PromoBoxEditView/localizedImageUris/additionalProperty]: '${value}' expected to be of type string.` };
                }
                return { success: true, value: value };
              })(value),
            ];
          });
          if (parsed.find(([_, value]) => !value.success) !== undefined) {
            return {
              success: false,
              reason: `[#/components/schemas/PromoBoxEditView/localizedImageUris]: Reason(s): '${parsed
                .map(([_, value]) => value)
                .filter((p) => !p.success)
                .map((p) => p.reason)
                .join(", ")}'.`,
            };
          }
          return {
            success: true,
            value: Object.fromEntries(
              parsed.map(([key, value]) => {
                assert(value.success);
                return [key, value.value];
              }),
            ),
          };
        })();
        if (!parsed_additionalProperties.success) {
          return { success: false, reason: parsed_additionalProperties.reason };
        }
        return { success: true, value: { additionalProperties: parsed_additionalProperties.value } };
      })(value["localizedImageUris"]);
    })();
    if (!parsed_localizedImageUris.success) {
      return { success: false, reason: parsed_localizedImageUris.reason };
    }
    if (!hasProp(value, "localizedTitle")) {
      return { success: false, reason: `[#/components/schemas/PromoBoxEditView/localizedTitle]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'localizedTitle'.` };
    }
    const parsed_localizedTitle = ((): ParserResult<{ additionalProperties: Record<string, string> }> => {
      return ((value: unknown): ParserResult<{ additionalProperties: Record<string, string> }> => {
        if (typeof value !== "object") {
          return { success: false, reason: `[#/components/schemas/PromoBoxEditView/localizedTitle]: '${value}' expected to be of type 'object'.` };
        }
        if (value === null) {
          return { success: false, reason: `[#/components/schemas/PromoBoxEditView/localizedTitle]: '${value}' expected to not be null.` };
        }
        const parsed_additionalProperties = ((): ParserResult<Record<string, string>> => {
          const parsed = Object.entries(value).map(([key, value]): [string, ParserResult<string>] => {
            return [
              key,
              ((value: unknown): ParserResult<string> => {
                if (typeof value !== "string") {
                  return { success: false, reason: `[#/components/schemas/PromoBoxEditView/localizedTitle/additionalProperty]: '${value}' expected to be of type string.` };
                }
                return { success: true, value: value };
              })(value),
            ];
          });
          if (parsed.find(([_, value]) => !value.success) !== undefined) {
            return {
              success: false,
              reason: `[#/components/schemas/PromoBoxEditView/localizedTitle]: Reason(s): '${parsed
                .map(([_, value]) => value)
                .filter((p) => !p.success)
                .map((p) => p.reason)
                .join(", ")}'.`,
            };
          }
          return {
            success: true,
            value: Object.fromEntries(
              parsed.map(([key, value]) => {
                assert(value.success);
                return [key, value.value];
              }),
            ),
          };
        })();
        if (!parsed_additionalProperties.success) {
          return { success: false, reason: parsed_additionalProperties.reason };
        }
        return { success: true, value: { additionalProperties: parsed_additionalProperties.value } };
      })(value["localizedTitle"]);
    })();
    if (!parsed_localizedTitle.success) {
      return { success: false, reason: parsed_localizedTitle.reason };
    }
    if (!hasProp(value, "localizedWebLinks")) {
      return { success: false, reason: `[#/components/schemas/PromoBoxEditView/localizedWebLinks]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'localizedWebLinks'.` };
    }
    const parsed_localizedWebLinks = ((): ParserResult<{ additionalProperties: Record<string, string> }> => {
      return ((value: unknown): ParserResult<{ additionalProperties: Record<string, string> }> => {
        if (typeof value !== "object") {
          return { success: false, reason: `[#/components/schemas/PromoBoxEditView/localizedWebLinks]: '${value}' expected to be of type 'object'.` };
        }
        if (value === null) {
          return { success: false, reason: `[#/components/schemas/PromoBoxEditView/localizedWebLinks]: '${value}' expected to not be null.` };
        }
        const parsed_additionalProperties = ((): ParserResult<Record<string, string>> => {
          const parsed = Object.entries(value).map(([key, value]): [string, ParserResult<string>] => {
            return [
              key,
              ((value: unknown): ParserResult<string> => {
                if (typeof value !== "string") {
                  return { success: false, reason: `[#/components/schemas/PromoBoxEditView/localizedWebLinks/additionalProperty]: '${value}' expected to be of type string.` };
                }
                return { success: true, value: value };
              })(value),
            ];
          });
          if (parsed.find(([_, value]) => !value.success) !== undefined) {
            return {
              success: false,
              reason: `[#/components/schemas/PromoBoxEditView/localizedWebLinks]: Reason(s): '${parsed
                .map(([_, value]) => value)
                .filter((p) => !p.success)
                .map((p) => p.reason)
                .join(", ")}'.`,
            };
          }
          return {
            success: true,
            value: Object.fromEntries(
              parsed.map(([key, value]) => {
                assert(value.success);
                return [key, value.value];
              }),
            ),
          };
        })();
        if (!parsed_additionalProperties.success) {
          return { success: false, reason: parsed_additionalProperties.reason };
        }
        return { success: true, value: { additionalProperties: parsed_additionalProperties.value } };
      })(value["localizedWebLinks"]);
    })();
    if (!parsed_localizedWebLinks.success) {
      return { success: false, reason: parsed_localizedWebLinks.reason };
    }
    if (!hasProp(value, "loggedIn")) {
      return { success: false, reason: `[#/components/schemas/PromoBoxEditView/loggedIn]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'loggedIn'.` };
    }
    const parsed_loggedIn = ((): ParserResult<boolean> => {
      return ((value: unknown): ParserResult<boolean> => {
        if (typeof value !== "boolean") {
          return { success: false, reason: `[#/components/schemas/PromoBoxEditView/loggedIn]: '${value}' expected to be of type boolean.` };
        }
        return { success: true, value: value };
      })(value["loggedIn"]);
    })();
    if (!parsed_loggedIn.success) {
      return { success: false, reason: parsed_loggedIn.reason };
    }
    if (!hasProp(value, "loggedOut")) {
      return { success: false, reason: `[#/components/schemas/PromoBoxEditView/loggedOut]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'loggedOut'.` };
    }
    const parsed_loggedOut = ((): ParserResult<boolean> => {
      return ((value: unknown): ParserResult<boolean> => {
        if (typeof value !== "boolean") {
          return { success: false, reason: `[#/components/schemas/PromoBoxEditView/loggedOut]: '${value}' expected to be of type boolean.` };
        }
        return { success: true, value: value };
      })(value["loggedOut"]);
    })();
    if (!parsed_loggedOut.success) {
      return { success: false, reason: parsed_loggedOut.reason };
    }
    if (!hasProp(value, "mobile")) {
      return { success: false, reason: `[#/components/schemas/PromoBoxEditView/mobile]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'mobile'.` };
    }
    const parsed_mobile = ((): ParserResult<boolean> => {
      return ((value: unknown): ParserResult<boolean> => {
        if (typeof value !== "boolean") {
          return { success: false, reason: `[#/components/schemas/PromoBoxEditView/mobile]: '${value}' expected to be of type boolean.` };
        }
        return { success: true, value: value };
      })(value["mobile"]);
    })();
    if (!parsed_mobile.success) {
      return { success: false, reason: parsed_mobile.reason };
    }
    if (!hasProp(value, "name")) {
      return { success: false, reason: `[#/components/schemas/PromoBoxEditView/name]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'name'.` };
    }
    const parsed_name = ((): ParserResult<string> => {
      return ((value: unknown): ParserResult<string> => {
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/PromoBoxEditView/name]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["name"]);
    })();
    if (!parsed_name.success) {
      return { success: false, reason: parsed_name.reason };
    }
    if (!hasProp(value, "promoBoxId")) {
      return { success: false, reason: `[#/components/schemas/PromoBoxEditView/promoBoxId]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'promoBoxId'.` };
    }
    const parsed_promoBoxId = ((): ParserResult<number> => {
      return ((value: unknown): ParserResult<number> => {
        if (typeof value === "number") {
          return { success: true, value: value };
        }
        return { success: false, reason: `[#/components/schemas/PromoBoxEditView/promoBoxId]: '${value}' expected to be of type number.` };
      })(value["promoBoxId"]);
    })();
    if (!parsed_promoBoxId.success) {
      return { success: false, reason: parsed_promoBoxId.reason };
    }
    if (!hasProp(value, "requiredFeatures")) {
      return { success: false, reason: `[#/components/schemas/PromoBoxEditView/requiredFeatures]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'requiredFeatures'.` };
    }
    const parsed_requiredFeatures = ((): ParserResult<string[]> => {
      return ((value: unknown): ParserResult<string[]> => {
        if (!isArray(value)) {
          return { success: false, reason: `[#/components/schemas/PromoBoxEditView/requiredFeatures]: '${value}' expected to be an array.` };
        }
        const parsed = value.map((value: unknown): ParserResult<string> => {
          if (typeof value !== "string") {
            return { success: false, reason: `[#/components/schemas/PromoBoxEditView/requiredFeatures]: '${value}' expected to be of type string.` };
          }
          return { success: true, value: value };
        });
        if (parsed.find((value) => !value.success) !== undefined) {
          return {
            success: false,
            reason: `[#/components/schemas/PromoBoxEditView/requiredFeatures]: Reason(s): '${parsed
              .filter((p) => !p.success)
              .map((p) => p.reason)
              .join(", ")}'.`,
          };
        }
        return {
          success: true,
          value: parsed.map((entry) => {
            assert(entry.success == true);
            return entry.value;
          }),
        };
      })(value["requiredFeatures"]);
    })();
    if (!parsed_requiredFeatures.success) {
      return { success: false, reason: parsed_requiredFeatures.reason };
    }
    if (!hasProp(value, "startsAt")) {
      return { success: false, reason: `[#/components/schemas/PromoBoxEditView/startsAt]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'startsAt'.` };
    }
    const parsed_startsAt = ((): ParserResult<{ year: number; month: number; day: number } | null> => {
      return ((value: unknown): ParserResult<{ year: number; month: number; day: number } | null> => {
        if (value === null) {
          return { success: true, value: null };
        }
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/PromoBoxEditView/startsAt]: '${value}' expected to be of type string.` };
        }
        const parsed = DateTime.fromFormat(value, "yyyy-LL-dd");
        if (!parsed.isValid) {
          return { success: false, reason: `[#/components/schemas/PromoBoxEditView/startsAt]: '${value}' expected to be a valid date in format yyyy-LL-dd.` };
        }
        return { success: true, value: { year: parsed.year, month: parsed.month, day: parsed.day } };
      })(value["startsAt"]);
    })();
    if (!parsed_startsAt.success) {
      return { success: false, reason: parsed_startsAt.reason };
    }
    if (!hasProp(value, "tag")) {
      return { success: false, reason: `[#/components/schemas/PromoBoxEditView/tag]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'tag'.` };
    }
    const parsed_tag = ((): ParserResult<PromoBoxTag> => {
      return ((value: unknown): ParserResult<PromoBoxTag> => {
        return ((
          value: unknown,
        ): ParserResult<
          | "UNDEFINED"
          | "EXPERT_WEBINAR"
          | "PRO_TALK"
          | "FEATURED"
          | "FEATURED_SUMMARY"
          | "FEATURED_ACTIONABLE"
          | "FEATURED_TOPIC"
          | "EMERGING_TREND"
          | "INTERNATIONAL_DAY"
          | "LEARNING_AT_WORK_WEEK"
          | "Q_A"
          | "VALUES_AND_CAPABILITIES"
          | "RECOMMENDED_READS"
          | "INTERNAL_THOUGHT_LEADER"
          | "READING_CALENDAR"
          | "NEW"
          | "SPOTLIGHT"
          | "PROMOTION"
          | "DEAL"
          | "NEWS"
          | "CAMPAIGN"
          | "BOOK_AWARD"
        > => {
          if (typeof value !== "string") {
            return { success: false, reason: `[#/components/schemas/PromoBoxTag]: '${value}' expected to be of type string.` };
          }
          switch (value) {
            case "UNDEFINED":
              return { success: true, value: "UNDEFINED" };
            case "EXPERT_WEBINAR":
              return { success: true, value: "EXPERT_WEBINAR" };
            case "PRO_TALK":
              return { success: true, value: "PRO_TALK" };
            case "FEATURED":
              return { success: true, value: "FEATURED" };
            case "FEATURED_SUMMARY":
              return { success: true, value: "FEATURED_SUMMARY" };
            case "FEATURED_ACTIONABLE":
              return { success: true, value: "FEATURED_ACTIONABLE" };
            case "FEATURED_TOPIC":
              return { success: true, value: "FEATURED_TOPIC" };
            case "EMERGING_TREND":
              return { success: true, value: "EMERGING_TREND" };
            case "INTERNATIONAL_DAY":
              return { success: true, value: "INTERNATIONAL_DAY" };
            case "LEARNING_AT_WORK_WEEK":
              return { success: true, value: "LEARNING_AT_WORK_WEEK" };
            case "Q_A":
              return { success: true, value: "Q_A" };
            case "VALUES_AND_CAPABILITIES":
              return { success: true, value: "VALUES_AND_CAPABILITIES" };
            case "RECOMMENDED_READS":
              return { success: true, value: "RECOMMENDED_READS" };
            case "INTERNAL_THOUGHT_LEADER":
              return { success: true, value: "INTERNAL_THOUGHT_LEADER" };
            case "READING_CALENDAR":
              return { success: true, value: "READING_CALENDAR" };
            case "NEW":
              return { success: true, value: "NEW" };
            case "SPOTLIGHT":
              return { success: true, value: "SPOTLIGHT" };
            case "PROMOTION":
              return { success: true, value: "PROMOTION" };
            case "DEAL":
              return { success: true, value: "DEAL" };
            case "NEWS":
              return { success: true, value: "NEWS" };
            case "CAMPAIGN":
              return { success: true, value: "CAMPAIGN" };
            case "BOOK_AWARD":
              return { success: true, value: "BOOK_AWARD" };
            default:
              return {
                success: false,
                reason: `[#/components/schemas/PromoBoxTag]: '${value}' expected to be enum, one of 'UNDEFINED, EXPERT_WEBINAR, PRO_TALK, FEATURED, FEATURED_SUMMARY, FEATURED_ACTIONABLE, FEATURED_TOPIC, EMERGING_TREND, INTERNATIONAL_DAY, LEARNING_AT_WORK_WEEK, Q_A, VALUES_AND_CAPABILITIES, RECOMMENDED_READS, INTERNAL_THOUGHT_LEADER, READING_CALENDAR, NEW, SPOTLIGHT, PROMOTION, DEAL, NEWS, CAMPAIGN, BOOK_AWARD'.`,
              };
          }
        })(value);
      })(value["tag"]);
    })();
    if (!parsed_tag.success) {
      return { success: false, reason: parsed_tag.reason };
    }
    if (!hasProp(value, "web")) {
      return { success: false, reason: `[#/components/schemas/PromoBoxEditView/web]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'web'.` };
    }
    const parsed_web = ((): ParserResult<boolean> => {
      return ((value: unknown): ParserResult<boolean> => {
        if (typeof value !== "boolean") {
          return { success: false, reason: `[#/components/schemas/PromoBoxEditView/web]: '${value}' expected to be of type boolean.` };
        }
        return { success: true, value: value };
      })(value["web"]);
    })();
    if (!parsed_web.success) {
      return { success: false, reason: parsed_web.reason };
    }
    if (!hasProp(value, "webLink")) {
      return { success: false, reason: `[#/components/schemas/PromoBoxEditView/webLink]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'webLink'.` };
    }
    const parsed_webLink = ((): ParserResult<string> => {
      return ((value: unknown): ParserResult<string> => {
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/PromoBoxEditView/webLink]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["webLink"]);
    })();
    if (!parsed_webLink.success) {
      return { success: false, reason: parsed_webLink.reason };
    }
    return {
      success: true,
      value: {
        backgroundColor: parsed_backgroundColor.value,
        brightTextColor: parsed_brightTextColor.value,
        corporateId: parsed_corporateId.value,
        designApproved: parsed_designApproved.value,
        endsAt: parsed_endsAt.value,
        excludedLanguages: parsed_excludedLanguages.value,
        imageUri: parsed_imageUri.value,
        localizedDescription: parsed_localizedDescription.value,
        localizedImageUris: parsed_localizedImageUris.value,
        localizedTitle: parsed_localizedTitle.value,
        localizedWebLinks: parsed_localizedWebLinks.value,
        loggedIn: parsed_loggedIn.value,
        loggedOut: parsed_loggedOut.value,
        mobile: parsed_mobile.value,
        name: parsed_name.value,
        promoBoxId: parsed_promoBoxId.value,
        requiredFeatures: parsed_requiredFeatures.value,
        startsAt: parsed_startsAt.value,
        tag: parsed_tag.value,
        web: parsed_web.value,
        webLink: parsed_webLink.value,
      },
    };
  })(parseJsonWithNumbersAsBigint(str));
}
